import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { PodcastCard as ExplorePodcastCard, SimulationCard as ExploreSimulationCard, CourseCard as ExploreCourseCard } from "src/pages/coaching/explore/card";
import { MyCourseCard, PodcastCard as MyPodcastCard, SimulationCard as MySimulationCard } from "src/pages/coaching/learnings/card";

import { Course } from "src/types/coaching/courses";
import { Simulation } from "src/types/coaching/simulation";
import { Podcast } from "src/types/coaching/podcast";
interface CoachingCardProps {
  learning: Course | Simulation | Podcast;
  filter: string;
}

const getLearningMeta = (learning: Course | Simulation | Podcast, filter: string) => {
  const isIncompleteLearning = filter === "incomplete_learnings";
  const learningData = learning as any;
  const courseData = learningData.course;

  return {
    learningType: learningData.courseType?.toLowerCase() ?? "",
    courseData,
    id: isIncompleteLearning ? learningData.learnerRecordId : courseData?.id,
    basePath: isIncompleteLearning ? "/coaching" : "/coaching/explore",
  };
};

export const CoachingCard: React.FC<CoachingCardProps> = ({ learning, filter }) => {
  const navigate = useNavigate();
  const isIncompleteLearning = filter === "incomplete_learnings";

  const {
    learningType,
    courseData,
    id,
    basePath,
  } = getLearningMeta(learning, filter);

  const handleClick = useCallback(() => {
    if (!learningType) return;
    navigate(`${basePath}/${learningType}s/${id}`);
  }, [basePath, id, learningType, navigate]);

  if (isIncompleteLearning) {
    return (
      <>
        {learningType === "course" && (
          <MyCourseCard course={learning as Course} onClick={handleClick} />
        )}
        {learningType === "podcast" && (
          <MyPodcastCard course={learning as Podcast} onClick={handleClick} />
        )}
        {learningType === "simulation" && (
          <MySimulationCard course={learning as Simulation} onClick={handleClick} />
        )}
      </>
    );
  }

  return (
    <>
      {learningType === "course" && (
        <ExploreCourseCard course={courseData as Course} onClick={handleClick} />
      )}
      {learningType === "podcast" && (
        <ExplorePodcastCard course={courseData as Podcast} onClick={handleClick} />
      )}
      {learningType === "simulation" && (
        <ExploreSimulationCard course={courseData as Simulation} onClick={handleClick} />
      )}
    </>
  );
};
